/**
 *
 */

export default {
    resort_1_restaurant_1: '2349289306', // Bergrestaurant Allmend
    resort_1_restaurant_2: '7181833241', // Berghaus Alpiglen
    resort_1_restaurant_5: '371692064', // Bahnhofbuffett Röstizza Kleine Scheidegg
    resort_1_restaurant_7: '318273153', // Restaurant Brandegg
    resort_1_restaurant_8: '3065324623', // Restaurant Eigergletscher
    resort_1_restaurant_9: '174290080', // Eigernordwand
    resort_1_restaurant_10: '62015166', // Restaurant Grindelwaldblick
    resort_1_restaurant_11: '4487092641', // Restaurant Crystal - Jungfraujoch
    resort_1_restaurant_12: '131469827', // Berghaus Männlichen
    resort_1_restaurant_14: '4486633194', // Skibar Läger
    resort_1_restaurant_15: '281792944', // Wäschbar
    resort_1_restaurant_16: '300421692', // Startbar Lauberhorn
    resort_1_restaurant_17: '3116771047', // Wengernalp
    resort_1_restaurant_18: '242194697', // Spycherbar Männlichen
    resort_1_restaurant_33: '4500580132', // Skibar Schreinerei
    resort_1_restaurant_19: '4486683440', // Holzerbar
    resort_1_restaurant_20: '4486683305', // Schigrill & Bar Gysibielen
    resort_1_restaurant_21: '4486694425', // Vorsaas Stube
    resort_1_restaurant_22: '546892824', // Chalet-Restaurant Bodenwald
    resort_1_restaurant_23: '282180986', // Quicky-Bar
    resort_1_restaurant_1000: '774640849', // Schürlibar
    resort_1_restaurant_1002: '283714263', // Mary's Cafe
    resort_1_restaurant_1004: '7188808790', // Aspen Restaurant
    resort_1_restaurant_1005: '174290083', // Chalet Bar
    resort_1_restaurant_1007: '3547329759', // Restaurant Grund
    resort_1_restaurant_1008: '7263068757', // Restaurant Derby
    resort_1_restaurant_1009: '7263096561', // Holdrio Bar
    resort_1_restaurant_1010: '546892579', // Stallbeizli Heuboden
    resort_1_restaurant_1011: '1446809460', // Jägerstübli
    resort_1_restaurant_1012: '10185558251', // Buschdiglen Bar

    resort_1_restaurant_1013: '12306505856', // Snackbar Innerwengen

    resort_2_restaurant_1: '256160861', // Panorama Restaurant Allmendhubel
    resort_2_restaurant_3: '7183622958', // Bistro Birg
    resort_2_restaurant_4: '241387277', // Gimmeln
    resort_2_restaurant_5: '230567291', // Schilthorn Piz Gloria
    resort_2_restaurant_6: '226981814', // Schilthornhütte
    resort_2_restaurant_7: '7227074598', // Schiltgrathuesi Restaurant
    resort_2_restaurant_8: '548551408', // Restaurant- Hotel Sonnenberg
    resort_2_restaurant_9: '352296948', // Im Suppen
    resort_2_restaurant_10: '46958678', // Bergrestaurant Winteregg
    resort_3_restaurant_2: '7183706111', // Bergrestaurant Bort
    resort_3_restaurant_3: '228730592', // Bergrestaurant Bussalp
    resort_3_restaurant_4: '276642250', // Bergrestaurant Schreckfeld
    resort_3_restaurant_5: '1873470971', // Berggasthaus First
    resort_3_restaurant_11: '4486707871', // Rasthysi
    resort_3_restaurant_12: '302386906', // Berggasthaus Waldspitz
    resort_3_restaurant_14: '206160443', // Rancher Bar
    resort_3_restaurant_26: '1620300824', // Adi's Skibar
    resort_3_restaurant_28: '4487022360', // Bus Stop Après Ride Bar
    resort_3_restaurant_29: '278873492', // Pisten Beizi Alpwäg Bar
    resort_3_restaurant_25: '276657286', // Brüggbeizli
    resort_3_restaurant_30: '276649914', // Bärgelegghütte
    resort_3_restaurant_1001: '348500275', // Hotel Wetterhorn
    resort_3_restaurant_1008: '7263068757', // Restaurant Derby



};
